import { type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Surface card (visual-restyle plan §1 "Hero card" + "Surface card").
 *
 * A warm surface on the cream/coffee canvas, `bg-white` / `bg-coffee-900`.
 *   - `hero`    → the composer surface: `rounded-2xl`, a thin hairline border,
 *     a soft lift shadow — Claude's promptbox treatment (filled, rounded, lifted).
 *   - `surface` → `rounded-xl` + hairline border — Settings cards, drawers.
 *
 * Lexiun-local (§10).
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "hero" | "surface";
}

export function Card({ variant = "surface", className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        "bg-white dark:bg-coffee-900",
        variant === "hero"
          ? "rounded-2xl border border-cream-200/60 p-4 shadow-[0_1px_2px_rgba(28,24,20,0.04),0_8px_24px_rgba(28,24,20,0.06)] dark:border-coffee-700/60"
          : "rounded-xl border border-cream-200/60 p-4 dark:border-coffee-700/60",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
